module.exports = __webpack_public_path__ + "assets/img/masterpass.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/masterpass.png
// module id = 413
// module chunks = 0